import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.regexp.match";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import cookie from '@tencent/vft-common/cookie';
import env from '@tencent/vft-common/env';
import logger from '@tencent/vft-common/logger';
import { getUrlParam } from '@tencent/vft-common/util.esm';
import { COOKIE_EXPIRED_TIME, PTLOGIN_COOKIE, TV_APPIDS, VIDEO_COOKIES } from "./utils/config";
import { clearPageCookies, clearRefreshTimeCookies, clearRootDomainCookies, clearUserCookies, clearVideoDomainCookies, getDomain, getSkey, isNativeLogin, setUserInfo, time33 } from "./utils/helper";
import IframeCookieLoader from "./utils/IframeCookieLoader";
import * as reporter from "./utils/report";
import * as service from "./utils/service";

/**
 * 判断当前是否是 video.qq.com 域
 * @returns {Boolean}
 */
function isVideoDomain() {
  return /\.video\.qq\.com$/.test(location.host);
}

/**
 * 获取登录态类型
 */
export function loginType() {
  var loginType = cookie.get('main_login');
  if (loginType === 'none') {
    return '';
  }
  return loginType || '';
}

/**
 * 同步登录态
 */
export function syncCookies(_x) {
  return _syncCookies.apply(this, arguments);
}
function _syncCookies() {
  _syncCookies = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(callback) {
    var cookieDomain, cookies, preType;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // 通过平台号确定是否需要同步cookie
            // 如果当前业务获取不到 cookie 域名，则不做后续同步逻辑
            cookieDomain = getDomain();
            if (!(env.isApp || isNativeLogin() || isVideoDomain() || !cookieDomain)) {
              _context.next = 4;
              break;
            }
            callback && callback();
            return _context.abrupt("return");
          case 4:
            _context.prev = 4;
            _context.next = 7;
            return IframeCookieLoader.getInstance().getVideoCookie();
          case 7:
            cookies = _context.sent;
            preType = cookies.main_login === 'qq' ? 'wx' : 'qq';
            if (cookie.get("".concat(preType, "_nick")) || cookie.get("".concat(preType, "_head"))) {
              cookie.remove("".concat(preType, "_nick"), {
                domain: cookieDomain,
                path: '/'
              });
              cookie.remove("".concat(preType, "_head"), {
                domain: cookieDomain,
                path: '/'
              });
            }

            // 同步 cookie
            VIDEO_COOKIES.forEach(function (key) {
              // fix: 以前的逻辑 cookie 是种在当前域，需要先移出当前域名的 cookie 信息，再同步
              // 新逻辑 cookie 种在三级域名，如 m.v.qq.com，cookie 种在 v.qq.com
              if (cookieDomain !== location.host) {
                cookie.remove(key, {
                  domain: location.host
                });
              }
              cookie.set(key, cookies[key] || '', {
                expires: cookies[key] ? COOKIE_EXPIRED_TIME : -24,
                domain: cookieDomain,
                path: '/'
              });
            });
            callback && callback();
            reporter.report({
              f_event: reporter.EVENT_INIT_SYNC
            });
            _context.next = 20;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](4);
            logger.error('syncCookies caught error', _context.t0);
            callback && callback();
            reporter.report({
              f_event: reporter.EVENT_INIT_SYNC,
              f_msg: "syncCookies caught error = ".concat(_context.t0.toString())
            });
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 15]]);
  }));
  return _syncCookies.apply(this, arguments);
}
var refreshTime = 0;
var maxRefreshTime = 2;

/**
 * 续期登录态
 */
export function refreshAuthToken(_x2, _x3) {
  return _refreshAuthToken.apply(this, arguments);
}

/**
 * 续期定时器
 * @param {Number} nextTime 下次续期时间/s
 */
function _refreshAuthToken() {
  _refreshAuthToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(type, callback) {
    var appid, cookieDomain, csrfParam, data, cookieOption, PREFIX, _callback2;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (typeof type === 'function') {
              callback = type;
              type = loginType() || 'qq';
            }
            appid = cookie.get('vqq_appid') || cookie.get('appid');
            cookieDomain = getDomain(); // TV登录态不过续期或者当前域名不在白名单
            if (!(TV_APPIDS.indexOf(appid) > -1 || !cookieDomain)) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return", callback());
          case 5:
            csrfParam = buildCSRF();
            _context2.prev = 6;
            _context2.next = 9;
            return service.authRefresh(_objectSpread({
              type: type
            }, csrfParam));
          case 9:
            data = _context2.sent;
            cookieOption = {
              expires: COOKIE_EXPIRED_TIME,
              domain: cookieDomain,
              path: '/'
            }; // 无需再次同步登录态信息到 video.qq.com 域包括子域，避免冲突
            if (!isVideoDomain()) {
              if (type === 'qq' && cookie.get('vqq_appid') && cookie.get('vqq_openid')) {
                PREFIX = type === 'qq' ? 'vqq_' : '';
                Object.keys(data).forEach(function (key) {
                  if (VIDEO_COOKIES.indexOf(key) > -1) {
                    cookie.set(PREFIX + key, data[key] || '', {
                      expires: data[key] ? COOKIE_EXPIRED_TIME : -24,
                      domain: cookieDomain,
                      path: '/'
                    });
                  }
                });
              } else {
                cookie.set('vuserid', data.vuserid, cookieOption);
                cookie.set('vusession', data.vusession, cookieOption);
              }
            }
            // 同步用户头像昵称，用于展示用
            cookie.set("".concat(type, "_nick"), data.nick, cookieOption);
            cookie.set("".concat(type, "_head"), data.head, cookieOption);
            cookie.set('last_refresh_time', +new Date(), cookieOption);
            cookie.set('last_refresh_vuserid', data.vuserid, cookieOption);
            updateAuthRefreshTimer(Number(data.next_refresh_time));
            callback && callback();
            _context2.next = 23;
            break;
          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](6);
            if ([-1001, -1002, -1003, -1004, 1006, 1111, 1112].indexOf(_context2.t0.code) > -1) {
              clearCookie(function () {
                var _callback;
                return (_callback = callback) === null || _callback === void 0 ? void 0 : _callback(_context2.t0);
              });
            } else {
              if (refreshTime < maxRefreshTime) {
                refreshAuthToken(callback);
              } else {
                (_callback2 = callback) === null || _callback2 === void 0 ? void 0 : _callback2(_context2.t0);
              }
              refreshTime += 1;
            }
          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[6, 20]]);
  }));
  return _refreshAuthToken.apply(this, arguments);
}
var refreshTimer = null;
function updateAuthRefreshTimer() {
  var nextTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if (refreshTimer) clearTimeout(refreshTimer);
  if (nextTime > 0) {
    refreshTimer = setTimeout(function () {
      refreshAuthToken();
      clearTimeout(refreshTimer);
    }, nextTime * 1000);
  }
}
var retryTime = 0;
export function innerToken2tenvideo(callback) {
  var msdkEncodeParam = getUrlParam('msdkEncodeParam');
  if (env.isMsdk && !msdkEncodeParam) {
    // 游戏场景，如果没有msdk参数，无法做票据转换，一般这种情况是已登录的case
    return callback();
  }
  // 先清Cookie，是为了避免拿到污染的票据信息
  // 由于换票据受限于客户端切换登录，不会同步清掉当前域下cookie
  // 在体育场景，登录类型字段 main_login 与主站一样，会造成切换账号后仍然拿到上一次票据信息
  clearCookie(function () {
    var loginType = '';
    var isMsdk = msdkEncodeParam.length > 0;
    var data = {};
    if (isMsdk) {
      data = {
        appid: getUrlParam('appid'),
        openid: getUrlParam('openid'),
        algorithm: getUrlParam('algorithm'),
        version: getUrlParam('version'),
        timestamp: +getUrlParam('timestamp'),
        sig: getUrlParam('sig'),
        encode: 2,
        msdkEncodeParam: msdkEncodeParam
      };
      loginType = data.appid.match(/^[0-9]+$/) ? 'qq' : 'wx';
    } else if (env.isWeishi) {
      // 腾讯微视支持使用票据转换打通登录态
      loginType = +cookie.get('iAuthType') === 1 ? 'qq' : 'wx';
    } else if (env.isQQSports) {
      // 腾讯体育支持使用票据转换打通登录态
      loginType = cookie.get('main_login');
    } else if (env.isQQMusic) {
      // QQ音乐, 目前只支持QQ登录态换票据,微信由于缺少access_token
      var tmeLoginType = +cookie.get('tmeLoginType');
      if (tmeLoginType === 2) {
        loginType = 'qq';
      } else if (tmeLoginType === 1) {
        loginType = 'wx';
      }
    }
    if (!loginType) {
      // 未登录
      return callback();
    }
    if (env.isWeishi) {
      if (loginType === 'qq' && cookie.get('sSessionKey')) {
        cookie.set('accessToken', cookie.get('sSessionKey'), {
          domain: '.qq.com',
          path: '/'
        });
      }
      // 原因微视安卓端在登录态打通版本8.19.1前，也写了视频票据，但写的是空数据，导致cookie污染问题
      clearRootDomainCookies();
    }

    // type: 2 // 1|非游戏QQ互联，2|非游戏微信，3|游戏msdk
    var type;
    if (isMsdk) {
      type = 3;
    } else if (loginType === 'qq') {
      type = 1;
    } else {
      type = 2;
    }
    service.thirdLogin(type, data).then(function (res) {
      setUserInfo(res);
      callback();
    }).catch(function (e) {
      logger.error('innerToken2tenvideo caught error', e);
      if (retryTime < 1) {
        innerToken2tenvideo(callback);
        retryTime += 1;
      } else {
        callback();
      }
    });
  });
}

/**
 * 清除登录态
 * @param {String} [type] 账号类型
 * @param {Function} callback 回调
 */
export function clearCookie(_x4, _x5) {
  return _clearCookie.apply(this, arguments);
}

/**
 *
 * @param {String} type 账号类型
 * @param {Function} callback 回调函数
 */
function _clearCookie() {
  _clearCookie = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type, callback) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (cookie.get('uin') || cookie.get('luin')) {
              PTLOGIN_COOKIE.forEach(function (key) {
                cookie.remove(key, {
                  domain: 'qq.com',
                  path: '/'
                });
              });
            }
            if (typeof type === 'function') {
              callback = type;
              type = loginType() || 'qq';
            }

            // 清除当前域下 Cookie 信息
            clearPageCookies();
            clearRefreshTimeCookies();
            clearUserCookies();
            _context3.next = 7;
            return clearVideoDomainCookies();
          case 7:
            callback();
          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _clearCookie.apply(this, arguments);
}
export function authLogout(type) {
  var params = {
    type: type
  };
  var wxAppid = cookie.get('appid');
  if (type === 'qq' && wxAppid && wxAppid.match(/^wx/)) {
    // 20210521: 强匹配微信appid，因为存在老qq登录时，appid=3000501，这种appid会导致后台取值异常
    // 同时存在QQ和微信登录时，由于原先V站切互联时遇到一些未明原因的问题，juliehwang 在清QQ登录态时，把微信的 appid 也清了
    // 现在增加参数来确保不清微信的 appid
    params.keepwx = '1';
  }
  if (!params.type) {
    // 默认清掉微信和QQ在当前页面的票据，避免票据污染，特别在升级登录态打通场景
    // 容易出现 film.qq.com 的cookie与 qq.com 的cookie相互影响
    params.type = loginType() || 'qq';
  }
  return service.authLogout(params);
}

/**
 * 根据登录态生成 gtk 加密串，用于校验视频票据
 * @return {Object}
 * @property {string} g_tk skey 票据.
 * @property {string} g_vstk 互联和微信 vusession 票据.
 * @property {string} g_actk 互联和微信 access_token 票据.
 */
export function buildCSRF() {
  var params = {};
  var type = loginType();
  if (type === 'qq') {
    var skey = getSkey();
    if (skey) {
      params.g_tk = time33(skey);
    }
    var vs = cookie.get('vqq_vusession');
    if (vs) {
      params.g_vstk = time33(vs);
    }
    var ac = cookie.get('vqq_access_token');
    if (ac) {
      params.g_actk = time33(ac);
    }
  } else if (type === 'wx') {
    var _vs = cookie.get('vusession');
    if (_vs) {
      params.g_vstk = time33(_vs);
    }
    var _ac = cookie.get('access_token');
    if (_ac) {
      params.g_actk = time33(_ac);
    }
  }
  return params;
}